import { render, staticRenderFns } from "./editModifierGroup.vue?vue&type=template&id=6439c6d0&scoped=true&"
import script from "./editModifierGroup.vue?vue&type=script&lang=js&"
export * from "./editModifierGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6439c6d0",
  null
  
)

export default component.exports